import React from "react";
import styled from "styled-components";

import { FieldWrapper, TextInputField } from '..'
import { NameInputFieldProps } from "./NameInputField.types";

export const Component: React.FC<NameInputFieldProps & {className: string }> = (props) => {
  const {
    names = {
      lastName: 'lastName',
      firstName: 'firstName',
    },
    placeholders,
    labels,
    maxLength,
    minLength,
    pattern,
    required,
    disabled,
    register,
    errors,
  } = props

  return (
    <FieldWrapper
      label={props.label}
      isRequired={props.required}
      column={props.column}
      error={!!(errors[names.lastName] || errors[names.firstName]) ? {message: ''} : undefined}
    >
      <div className={`${props.className} name-wrapper`}>
        <TextInputField
          label={labels?.lastName}
          column
          name={names.lastName}
          register={register}
          required={required}
          error={errors[names.lastName]}
          placeholder={placeholders?.lastName || ''}
          disabled={disabled}
          pattern={pattern}
          maxLength={maxLength}
          minLength={minLength}
        />
        <TextInputField
          label={labels?.firstName}
          column
          name={names.firstName}
          register={register}
          required={required}
          error={errors[names.firstName]}
          placeholder={placeholders?.firstName || ''}
          disabled={disabled}
          pattern={pattern}
          maxLength={maxLength}
          minLength={minLength}
        />
      </div>
    </FieldWrapper>
  );
};

export const NameInputField: React.FC<NameInputFieldProps> = styled(Component)`
  &.name-wrapper {
    display: flex;
    gap: 8px;

    > div {
      @media (max-width: 520px) {
        width: 160px;
      }
    }
  }
`;
